import { Scene } from '@babylonjs/core';
import { BabylonjsModule } from '@modules/babylonjs';
import { useZed } from '@modules/core';
import { lazy, memo, Suspense, useCallback, useEffect, useState } from 'react';

declare global {
  interface Window {
    toggleInspector?: () => void;
  }
}

const InspectorProvider = lazy(() => import('./InspectorProvider'));

export const InspectorComponent = memo(function InspectorComponent() {
  const zed = useZed<[BabylonjsModule]>();
  const [scene, setScene] = useState<Scene | undefined>();
  const [showInspector, setShowInspector] = useState(false);

  const toggleInspector = useCallback(() => {
    setShowInspector(!showInspector);
  }, [showInspector]);

  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.code === 'Backquote') {
        toggleInspector();
      }
    },
    [toggleInspector]
  );

  useEffect(() => {
    setScene(zed?.api.scene);
  }, [zed]);

  useEffect(() => {
    if (!scene) {
      return;
    }

    window.toggleInspector = toggleInspector;

    window.addEventListener('keydown', onKeyDown, false);

    return () => {
      window.removeEventListener('keydown', onKeyDown, false);
      delete window.toggleInspector;
    };
  }, [scene, toggleInspector]);

  return (
    showInspector &&
    scene && (
      <Suspense>
        <InspectorProvider scene={scene} />
      </Suspense>
    )
  );
});
